<template>
  <nav class="navbar navbar-light fixed-top" v-if="cart.length >= 0">
    <div class="navbar-text ms-auto d-flex">
      <button class="btn btn-sm btn-outline-success me-3" @click="$emit('toggle-slide')">
        <font-awesome-icon icon="dollar-sign"></font-awesome-icon>
      </button>
      <div class="dropdown ms-2" v-if="cart.length > 0">
        <button
          class="btn btn-success btn-sm dropdown-toggle me-2"
          id="dropdownCart"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span class="badge badge-pill badge-success">{{ cartQty }}</span>
          <font-awesome-icon icon="cart-shopping" class="me-2"></font-awesome-icon>
          <price :value="Number(cartTotal)"></price>
        </button>
        <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownCart">
          <div v-for="(item, index) in cart" :key="index">
            <div
              class="d-flex justify-content-between align-items-center gap-2 dropdown-item-text text-nowrap text-right"
            >
              <span class="badge bg-warning text-dark me-1">
                {{ item.qty }}
              </span>
              {{ item.product.name }}
              <b>{{ (item.product.price * item.qty) | currencyFormat }}</b>
              <a href="#" class="badge bg-danger text-white" @click.stop="$emit('delete-item', index)">-</a>
            </div>
          </div>
          <router-link class="btn btn-sm btn btn-outline-info text-dark float-end me-2" to="/checkout">
            Checkout
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Price from './Price.vue';
export default {
  name: 'navbar',
  components: {
    Price
  },
  props: ['cart', 'cartQty', 'cartTotal'],
  filters: {
    currencyFormat: function (value) {
      return 'Rp' + Number.parseFloat(value).toFixed(2);
    }
  }
};
</script>
